angular.module('nv.shared.services.support-schedule', []);
